export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const CLEAR_USER_PROFILE = 'CLEAR_USER_PROFILE';
export const SET_USER_PERMISSION = 'SET_USER_PERMISSION';
export const CLEAR_USER_PERMISSION = 'CLEAR_USER_PERMISSION';

export const SET_PAGE_LOAD = 'SET_PAGE_LOAD';
export const CLEAR_PAGE_LOAD = 'CLEAR_PAGE_LOAD';

export const PROGRESS_LOADING = 'PROGRESS_LOADING';
